import PaymentTermsView from './PaymentTermsView'; // New ViewComponent
import PaymentTermsList from './PaymentTermsList'; // New ListComponent
import SvgOptions from '../../../Components/Svg/SvgOptions'; // Adjust path

const PaymentTermsNavOptions = [
    {
        element: PaymentTermsView,
        path: ":id",
        access: { user: true, admin: true, super: true },
        Protected: false,
        default: true,
        icon: SvgOptions.Receipt, // Or a relevant icon
    },
];

const defaultRoute = {
    element: PaymentTermsList,
    path: "*",
    access: { user: true, admin: true, super: true },
    Protected: false,
    default: true,
    icon: SvgOptions.Receipt, // Or a relevant icon
};

export { defaultRoute };
export default PaymentTermsNavOptions;